import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  MdbModalModule, MdbModalRef, MdbSelectModule, MdbTabChange, MdbTabComponent, MdbTabsComponent, MdbTabsModule,
} from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { BehaviorSubject, filter, map, Observable, Subject, Subscription, tap } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { BiometricsModel } from 'src/app/core/models/biometrics.model';
import { BiometricsSerivce } from 'src/app/core/rest-services/biometrics.service';
import { QuoteStoreService } from 'src/app/core/rest-services/quote-store.service';
import { UserService } from 'src/app/core/services/lmsuser.service';

import { FingerNameEnum, LMSConstantsService } from '@lmsConstants';
import { LmsTableWrapperComponent } from '@lmsShared';
import { LmsModalFrameComponent } from '@lmsSharedUI';

export interface CustomerEnrollmentEntity {
  id?: number;
  idNumber?: string;
  userName?: string;
  fingerName?: FingerNameEnum;
  fmd?: string;
  created?: string;
  enrolledBy?: string;
  disabledAt?: string;
  disabledBy?: string;

  branchName?: string;

  faisRep?: boolean;
}

const NO_FINGER = 'NO_FINGER';

export interface SelectItem<T = any> {
  label?: string;
  value: T;
  styleClass?: string;
  icon?: string;
  title?: string;
  disabled?: boolean;
}

export interface LMS_BioCaptureModel {
  canDoEnroll: boolean;
  canDoVerify: boolean;
  clientVerified: boolean;
  userVerified: boolean;
  faisRepVerified: boolean;
  canDoStartAcquisition: boolean;
  isValidFingerSelected: boolean;
  readQuality: Observable<string>;
  numberReadings: Observable<number>;
  sampleData: Observable<string[]>;
  deviceList: Observable<string[]>;
}

@Component({
  selector: 'app-biometrics-dialog',
  templateUrl: './biometrics-dialog.component.html',
  styleUrls: ['./biometrics-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LmsModalFrameComponent,
    MdbModalModule,
    MdbSelectModule,
    MdbTabsModule,
    NgxPaginationModule,
    LmsTableWrapperComponent,
  ]
})
export class BiometricsDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MdbTabsComponent, { static: true, read: MdbTabsComponent }) tabsComponent: MdbTabsComponent;

  private _getAsyncElement(element: ElementRef, timeout: number, maxAttempt: number) {
    function repeateUntilSuccess(elementRef, resolve, reject, attemptCount) {
      if (!elementRef) {
        if (attemptCount >= maxAttempt) {
          reject(new Error('Max amount of attempt achived'));
        } else {
          // Repeat after timeout
          setTimeout(() => {
            repeateUntilSuccess(elementRef, resolve, reject, attemptCount + 1);
          }, timeout);
        }
      } else {
        resolve(elementRef);
      }
    }

    return new Promise<ElementRef | string>((resolve, reject) => {
      setTimeout(() => {
        repeateUntilSuccess(element, resolve, reject, 0);
      }, timeout);
    });
  }

  @ViewChild('allFingersSelect', { read: ElementRef, static:true }) allFinger: ElementRef;
  set allfingerelement(element: ElementRef) {
    if (element) {
      this.allFinger = element;
      if (
        ((this.biometricType as string).toLowerCase() == 'client' ||
          (this.biometricType as string).toLowerCase() == 'client-offer') &&
        this.clientEnrolled.length > 0
      ) {
        this.getFingersList(this.clientEnrolled, this.biometricType || 'client');
      }
      if ((this.biometricType as string).toLowerCase() == 'user' && this.userEnrolled.length > 0) {
        this.getFingersList(this.userEnrolled, this.biometricType || 'user');
      }
    }
  }

  @ViewChild('allFingersSelectUser', { read: ElementRef, static:true }) allFingerUser: ElementRef;
  set allfingerUserelement(element: ElementRef) {
    if (element) {
      this.allFingerUser = element;
      if (
        ((this.biometricType as string).toLowerCase() == 'client' ||
          (this.biometricType as string).toLowerCase() == 'client-offer') &&
        this.userEnrolled.length > 0
      ) {
        this.getFingersList(this.userEnrolled, this.biometricType || 'user');
      }
      if ((this.biometricType as string).toLowerCase() == 'user' && this.userEnrolled.length > 0) {
        this.getFingersList(this.userEnrolled, this.biometricType || 'user');
      }
    }
  }

  lstAllFingers = this.lmsConstantService.getLMSConstant('ALLFINGERS') || [];
  biometricsInfo: any;
  userBiometricsData:any;
  acquisitionStarted: boolean;
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 5,
    currentPage: 1,
  };
  config2: PaginationInstance = {
    id: 'pager2',
    itemsPerPage: 5,
    currentPage: 1,
  };
  biometricsModel: BiometricsModel = new BiometricsModel();
  dlgTitle: string = 'Biometric Enrollment';
  lmsbioCapture: LMS_BioCaptureModel;

  captureOpen = false;
  verificationOpen = false;
  userVerificationOpen = false;
  showDisabledTab = false;
  showUserDisabledTab = false;
  signatureOpen = false;
  faisrep_verified = false;
  deviceSerial: string;
  devicesList: string[];

  radioFormat: number;
  stopAcquisitionDisabled: boolean;
  startAcquisitionDisabled: boolean;

  fingerdisabled: number;
  enrollmentError?: string;
  enrollmentMessage?: string;
  clientEnrolled: CustomerEnrollmentEntity[] | [];
  userEnrolled: CustomerEnrollmentEntity[] | [];
  userRecord: CustomerEnrollmentEntity[] | [];

  otherUserEnrolled: CustomerEnrollmentEntity[] | [];

  verifiedRepFingers: CustomerEnrollmentEntity[] | [];

  verifiedFingers: CustomerEnrollmentEntity[] | [];
  fingerNames: SelectItem[];
  selectedFingerName: any;
  selectedConsultantFingerName: any;
  selectedFingerNameControl = new FormControl([{ value: null, disabled: false }]);
  biometricType: any;
  finger_processing = (oneSample: string[]): void => {};
  continueApplicationDisabled: boolean;

  enableSkip: boolean;
  //reasonSelected = false ;
  //lstBiometricsSkipReasons = SKIPBIOMETRICSREASONS;
  //lstDisableClientFingers = DISABLECLIENTFINGERS;
  lstVerifiedFingers: any;
  //disableReason: any;

  noBiometrics: boolean;
  lstAllFingersDisable: boolean;
  sampleDataVerify: string;
  lstSignedFingerDetails: any[];
  lstConsultantSignedFingerDetails: any[];

  isNokComplete: boolean;
  isCellVisible: boolean;
  bmVerified: boolean;
  submitted = false;
  skipBiometrics = false;

  showStatus = false;

  isFingerProcessing = new BehaviorSubject<boolean>(true);
  isFingerProcessing$ = this.isFingerProcessing?.asObservable();
  samplesFull = false;
  uniqueUsernames: any[] = [];

   repFingerId = 0;

  isUserBranchConsultant = this.userService.userJobTitle == 'Branch Consultant';
  isUserBranchManager =
    this.userService.userJobTitle == 'Branch Manager' ||
    this.userService.userJobTitle == 'System Owner';

  subscriptions: Subscription[] = [];
  constructor(
    public modalRef: MdbModalRef<BiometricsDialogComponent>,
    public quoteStoreService: QuoteStoreService,
    private biometricsService: BiometricsSerivce,
    private userService: UserService,
    public global_utility: AppUtilityService,
    private lmsConstantService: LMSConstantsService
  ) {
    this.deviceSerial = 'No Device Selected';
    this.devicesList = [];
    this.radioFormat = 2;
    this.stopAcquisitionDisabled = true;
    this.startAcquisitionDisabled = true;
    this.continueApplicationDisabled = true;

    this.enrollmentMessage = '';
    this.enrollmentError = '';
    this.clientEnrolled = [];
    this.userEnrolled = [];
    this.verifiedFingers = [];
    this.verifiedRepFingers = [];

    this.lmsbioCapture = {
      canDoEnroll: false,
      canDoVerify: false,
      clientVerified: false,
      userVerified: false,
      faisRepVerified: false,
      canDoStartAcquisition: false,
      isValidFingerSelected: false,
      readQuality: this.biometricsService.readQuality$,
      numberReadings: this.biometricsService.numberReadings$,
      sampleData: this.biometricsService.sampleData$,
      deviceList: this.biometricsService.deviceList$,
    };
  }

  ngOnInit(): void {
     this.repFingerId = this.biometricsInfo.faisRepFingerId || 0;
    console.debug('Biometrics info >>', this.biometricsInfo, `:: Fmt: ${this.radioFormat}`, `type: ${this.biometricType}`);

    this.tabsComponent.activeTabChange.subscribe((event) => this.activechanged(event));

    this.dlgTitle = this.biometricType == 'client-offer' ? 'Verify Biometric' : 'Enroll Biometric';
    this.verificationOpen = this.biometricType == 'client-offer';

     if(this.biometricType == 'client-offer'){
      this.loadVerifiedRepFingers();
    }

    let sub1 = this.lmsbioCapture.sampleData.subscribe((sample) => {
      if (sample.length > 0 && this.acquisitionStarted && this.isFingerProcessing?.getValue() === false) {
        this.finger_processing(sample);
      }
    });
    this.subscriptions.push(sub1);

    sub1 = this.lmsbioCapture.numberReadings.subscribe((readIdx) => {
      if (readIdx <= 0) {
        return;
      }
      console.log('Number of Readings: ', readIdx);
    });
    this.subscriptions.push(sub1);
    sub1 = this.biometricsService.acquisitionStarted$.subscribe((status) => {
      this.showMessage(`${status}, place your finger.`);
    });
    this.subscriptions.push(sub1);

    sub1 = this.biometricsService.status$.subscribe((status) => {
      this.showMessage(status);
    });
    this.subscriptions.push(sub1);

    sub1 = this.lmsbioCapture.deviceList.subscribe((devicelist: string[]) => {
      this.devicesList = devicelist;
      this.deviceSerial = devicelist.join(', ');
    });
    this.subscriptions.push(sub1);

    this.biometricsService.getDevices();
    this.lmsbioCapture.canDoEnroll = false;
    this.lmsbioCapture.canDoVerify = false;

    this.lmsbioCapture.faisRepVerified = (this.biometricsInfo.FaisRepRequired === false || this.biometricsInfo.FaisRepRequired === undefined || this.biometricsInfo.faisRepFingerId > 0) ? true : false;
  }

signatureChecker = new Subject<number>();
  readonly signatureOpen$ = this.signatureChecker.pipe(
    map((cansign: number) =>
      !cansign
        ? false
        : Boolean(
            this.verifiedFingers.length == 2 &&
              (this.verifiedRepFingers.length == 1 || (this.biometricsInfo.FaisRepRequired === false || this.biometricsInfo.FaisRepRequired === undefined)) &&
              this.lmsbioCapture.clientVerified &&
              this.lmsbioCapture.userVerified &&
              (this.lmsbioCapture.faisRepVerified || (this.biometricsInfo.FaisRepRequired === false || this.biometricsInfo.FaisRepRequired === undefined)) &&
              this.biometricType == 'client-offer'
          )
    )
  );

   loadVerifiedRepFingers() {//Double Check logic
  this.biometricsService.enrolledCallCentreRepUserFingersDetails(this.quoteStoreService.quoteWorkbook.faisRepFingerId)
    .subscribe((res:any) => {
      this.verifiedRepFingers = res;
    });
}

  ngAfterViewInit(): void {
    this.tabsComponent.activeTabChange.emit();

    //this._tabsComponent.setActiveTab(1);
  }

  get canStartScan() {
    return (
      !this.acquisitionStarted &&
      !this.startAcquisitionDisabled &&
      this.lmsbioCapture?.isValidFingerSelected &&
      this.isFingerProcessing.getValue() === false &&
      !this.samplesFull
    );
  }
  get canEnrollData() {
    const _canenroll = (
      this.isFingerProcessing.getValue() == false &&
      this.lmsbioCapture?.isValidFingerSelected &&
      this.samplesFull &&
      this.lmsbioCapture.canDoEnroll &&
      this.lmsbioCapture?.sampleData.pipe(
        map((data) => {
          return Boolean((data.length || 0) >= 4);
        })
      )
    );
    return _canenroll;
  }

  get canContinueApp() {
    return (
      !this.continueApplicationDisabled &&
      this.lmsbioCapture.clientVerified &&
      this.lmsbioCapture?.sampleData.pipe(
        map((data) => {
          return Boolean((data.length || 0) >= 4);
        })
      )
    );
  }

  showMessage(message) {
    const statusWindow = document.getElementById('status');
    if (statusWindow) {
        statusWindow.innerHTML = message;
    }
  }

  updateData(index: number, value: any) {
    this.lmsbioCapture.sampleData[index] = value;
    console.debug(`sampleData[${index}] >>>`, this.lmsbioCapture.sampleData[index]);
  }

  resetReaderData() {
    this.biometricsService.resetReadings();
  }

  activechanged(event: MdbTabChange) {
    if(!event){
      return;
    }
    this.selectedFingerName = '';
    console.debug('Event>>', event);
    const _tab: MdbTabComponent = this.tabsComponent?.tabs[event.index] || event?.tab;

    if (_tab) {
      _tab.fade = false;

      this.activeids = _tab.title.toLowerCase();
      this.startChange();
    } else {
      console.log('waiting for tabs');
    }
  }

  activeids: string = '';

  startChange = () => {
    setTimeout(() => {
      switch (this.activeids.toLowerCase()) {
        case "client-offer":
        case "client verify":
          //this.openCapture();
          this.lmsbioCapture.clientVerified = false;
          this.getClientEnrolledFingers();
          break;
        case "client capture":
          //this.openCapture();
          this.getClientEnrolledFingers();
          break;
        case 'fais rep verify':
          this.lmsbioCapture.faisRepVerified = false;
          this.getUserEnrolledFingers(true);
          break;
        //User Verify
        case "user verify":
          //this.openCapture();
          this.lmsbioCapture.userVerified = false;
          this.getUserEnrolledFingers(true);
          // this.openVerification();
          break;
        //User Capture
        case "user capture":
           this.getUserEnrolledFingers(true);
           // this.openVerification();

          break;
        case 'fais rep cpture':
          this.getUserEnrolledFingers(true);
          break;
        // Disable Client Fingers
        case "disable client fingers":
          if (!this.showDisabledTab && this.captureOpen) {
          }
          this.isFingerProcessing.next(false);
          break;
        //Disable User Fingers
        case "disable user fingers":
          if (!this.showUserDisabledTab && this.captureOpen) {
          }
          this.isFingerProcessing.next(false);
          break;
        default:
          this.isFingerProcessing.next(false);
          break;
      }
    },200);
  };

  getDevice() {
    this.biometricsService.getDevices();
  }

  startCapture(ignoreNoFinger: boolean = false, withProcessing: boolean = false) {
    if (this.acquisitionStarted) {
      console.debug('acquisitionStarted Already true, breaking!');
      return;
    }

    this.startAcquisitionDisabled = true;
    this.stopAcquisitionDisabled = false;

    if (this.selectedFingerName == 'NO_FINGER' && !ignoreNoFinger) {
      this.lmsbioCapture.canDoVerify = false;
      //this.skipBiometrics = this.biometricType != 'client-offer';
      withProcessing = false;
      this.acquisitionStarted = false;
      return;
    }

    if (withProcessing) {
      this.finger_processing = (oneSample: string[]) => {
        this.samplesFull = oneSample.length >= 4;
        if (oneSample.length >= 4) {
          this.biometricsModel.fingerImage1 = oneSample[0];
          this.biometricsModel.fingerImage2 = oneSample[1];
          this.biometricsModel.fingerImage3 = oneSample[2];
          this.biometricsModel.fingerImage4 = oneSample[3];

          this.stopReaderCapture(true, false);
        }
        return;
      };
    }

    this.acquisitionStarted = true;
    this.biometricsService.startAcquisition(true).catch((error: any) => {
      this.acquisitionStarted = false;
      console.error('Error starting capture >>', error);
      this.showMessage(error);
    });
  }

  private stopReaderCapture(resetReading: boolean = true, disableContinue: boolean = true) {
    this.biometricsService
      .stopAcquisition()
      .then(() => {
        this.startAcquisitionDisabled = true;
        this.stopAcquisitionDisabled = false;

        this.enrollmentError = '';
        this.acquisitionStarted = false;

        if (resetReading) {
          this.showStatus = false;
          this.biometricsService.resetReadings();
        }
        if (disableContinue) {
          this.lmsbioCapture.canDoEnroll = false;
          this.lmsbioCapture.canDoVerify = false;
          this.continueClientDisabled();
        }
      })
      .catch((error: any) => {
        console.error('Error stopping acquisition:', error);
      });
  }

  enrollClient() {
    if (!this.lmsbioCapture.isValidFingerSelected || !this.lmsbioCapture.canDoEnroll) {
      this.global_utility.warning('Please select a valid finger to enroll.', 'Enrollment Warning');
      return;
    }

    setTimeout(() => {
      this.biometricsModel.fingerName = this.selectedFingerName;
      this.biometricsModel.enrolledBy = this.userService.userLoginName;
      this.biometricsModel.idNumber = this.biometricsInfo?.idNumber;
      this.biometricsModel.branchName = this.userService.userBranchName ||this.biometricsInfo?.branchName;

      console.debug('Biometrics Model :: ', this.biometricsModel);
      this.showStatus = false;
      this.isFingerProcessing.next(true);

      this.biometricsService.enrollClientFinger(this.biometricsModel).subscribe({
        next: (response) => {
          console.debug('Enrollement Response >>>', response);
          // Assign errorCode and errorMessage from response to enrollmentError and enrollmentMessage respectively
          this.enrollmentError = response?.errorCode;
          this.enrollmentMessage = response?.errorMessage;

          if (this.enrollmentError != 'SUCCESS') {
            this.stopReaderCapture(true, false);
            this.global_utility.error(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'Enrollment Error: ');
            this.lmsbioCapture.canDoEnroll = true;
            this.lmsbioCapture.isValidFingerSelected = false;
            this.samplesFull = false;
            return;
          }

          // Reset selectedFingerName, stop client capture, and update enrolled and fingers list
          this.global_utility.success(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'Enrollment Status');
          this.selectedFingerNameControl.reset();
          this.selectedFingerName = '';
          this.samplesFull = false;
          this.lmsbioCapture.isValidFingerSelected = false;

          this.getClientEnrolledFingers(true);
        },
        complete: () => {
          this.isFingerProcessing.next(false);
          console.groupEnd();
        },
        error: (err) => {
          this.isFingerProcessing.next(false);
          this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
          console.error(err);
          console.groupEnd();
        },
      });
    });
  }

  doClientFingerVerify(clientFinger: CustomerEnrollmentEntity) {
    this.selectedFingerName = clientFinger?.fingerName;

    if (clientFinger?.fingerName == (NO_FINGER as FingerNameEnum)) {
      this.skipBiometrics = false;
      this.enableSkip = this.biometricType == 'client';
      this.selectedFingerName = NO_FINGER;
      if (this.biometricType == 'client-offer') {
        (this.verifiedFingers as CustomerEnrollmentEntity[]).unshift(clientFinger);
        this.lmsbioCapture.clientVerified =
          Array.from(this.verifiedFingers).length == 1 && this.verifiedFingers[0] != null;
           this.signatureChecker.next(1);
           this.tabsComponent?.setActiveTab(1);
      }
      return;
    }

    if (!this.lmsbioCapture.clientVerified && !this.acquisitionStarted) {
      this.showStatus = true;
      this.startCapture();
    }

    this.finger_processing = (oneSample: string[]) => {
      if ((!this.lmsbioCapture.clientVerified && this.lmsbioCapture.canDoVerify) || this.lmsbioCapture.canDoEnroll) {
        const sampleDataVerify = oneSample[0];
        const biometricsModel = {
          fingerImage: sampleDataVerify,
          verifiedBy: this.userService.userLoginName,
          branchName: this.biometricsInfo?.branchName || this.userBiometricsData?.branchName,
          idNumber: this.biometricsInfo?.idNumber,
        };

        this.samplesFull = oneSample.length >= 1;
        if (oneSample.length >= 1) {
          this.stopReaderCapture(true, false);
        }

        setTimeout(() => {
          this.isFingerProcessing.next(true);
          this.biometricsService.verifyClientFinger(biometricsModel).subscribe({
            next: (response) => {
              this.enrollmentError = response?.errorCode;
              this.enrollmentMessage = response?.errorMessage;

              const toastString = `Verify Finger Response: ${this.enrollmentError}`;
              this.quoteStoreService.setVerifiedMessage(this.enrollmentMessage);

              if (this.enrollmentError == 'FAILURE') {
                this.global_utility.warning(this.enrollmentMessage, toastString);

                if (this.biometricType == 'client-offer') {
                  this.signatureOpen = false;
                  this.lmsbioCapture.clientVerified = false;
                  (this.verifiedFingers as CustomerEnrollmentEntity[]).unshift({});
                }

                this.stopReaderCapture(true, false);
                this.isFingerProcessing.next(false);
                return;
              }

              this.global_utility.info(this.enrollmentMessage, toastString);
              this.noBiometrics =
                this.clientEnrolled.length <= 1 && this.clientEnrolled.some((f) => f.fingerName?.includes(NO_FINGER));
              this.lmsbioCapture.canDoEnroll = this.clientEnrolled.length < 4 && !this.noBiometrics;

              (this.verifiedFingers as CustomerEnrollmentEntity[]).unshift(clientFinger);
              this.lmsbioCapture.clientVerified =
                Array.from(this.verifiedFingers).length == 1 && this.verifiedFingers[0] != null;

              if (this.biometricType == 'client' && this.clientEnrolled.length == 4) {
                this.stopReaderCapture(false, false);
                this.isFingerProcessing.next(false);
                this.continueApplication();
                return;
              }

              if (this.biometricType == 'client-offer') {
                if (!this.enrollmentMessage || this.enrollmentMessage == '') {
                  this.lmsbioCapture.canDoVerify = false;
                }
                this.quoteStoreService
                  .auditLogClientFingerVerification(this.biometricsModel.idNumber, this.enrollmentMessage)
                  .subscribe();

                this.stopReaderCapture(true, false);
                 this.signatureChecker.next(1); //1
                this.tabsComponent?.setActiveTab(1);//1

              }
              this.isFingerProcessing.next(false);
            },
            complete: () => {
              this.isFingerProcessing.next(false);
              console.groupEnd();
            },
            error: (err) => {
              this.isFingerProcessing.next(false);
              this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
              console.error(err);
              console.groupEnd();
            },
          });
        });
      }
    };
  }

  doUserFingerVerify(userFinger: CustomerEnrollmentEntity) {
    this.selectedFingerName = userFinger?.fingerName;

    ///TODO: User Verification should not allow NO FINGER
    if (userFinger?.fingerName === (NO_FINGER as FingerNameEnum) && isDevMode()) {
      this.enableSkip = false; // User Verification not applicable on Biometric Skip
      this.selectedFingerName = NO_FINGER;
      //this.verifiedFingers[1] = userFinger;
      this.lmsbioCapture.userVerified = false;
      this.signatureOpen = false;
      return;
    }

    // If FaisRepRequired is undefined, treat it as false for this check
    if (!this.lmsbioCapture.userVerified && !this.acquisitionStarted &&
      (this.lmsbioCapture.faisRepVerified || (!this.biometricsInfo.FaisRepRequired === false || this.biometricsInfo.FaisRepRequired === undefined))) {
      this.showStatus = true;
      this.startCapture();
    }

    this.finger_processing = (oneSample: string[]) => {
      if ((!this.lmsbioCapture.userVerified && this.lmsbioCapture.canDoVerify) || this.lmsbioCapture.canDoEnroll) {
        const sampleDataVerify = oneSample[0];
        this.biometricsModel = {
          ...this.biometricsModel,
          fingerImage: sampleDataVerify,
          verifiedBy: this.userService.userLoginName,
          branchName: this.userBiometricsData?.branchName || this.biometricsInfo?.branchName,
          idNumber: this.biometricsInfo?.idNumber || this.biometricsInfo?.idNumber,
          userName:
            this.biometricType == 'client-offer' ? this.userService.userLoginName : this.biometricsInfo.loginName,
          //faisRep: this.biometricsInfo?.faisRep || this.userBiometricsInfo?.faisRep,
        };

        this.samplesFull = oneSample.length >= 1;
        if (oneSample.length >= 1) {
          this.stopReaderCapture(true, false);
        }

        if (this.biometricType == 'user') {
          this.biometricsModel.verifiedBy = this.biometricsInfo.loginName;
        }

        setTimeout(() => {
          this.isFingerProcessing.next(true);
          this.biometricsService.verifyUserFinger(this.biometricsModel).subscribe({
            next: (response) => {
              this.enrollmentError = response?.errorCode;
              this.enrollmentMessage = response?.errorMessage;

              const toastString = `Verify Finger Response: ${this.enrollmentError}`;
              this.quoteStoreService.setVerifiedMessage(this.enrollmentMessage);

              if (this.enrollmentError == 'FAILURE') {
                this.global_utility.warning(this.enrollmentMessage, toastString);
                this.biometricsModel.fingerVerified = false;

                if (this.biometricType == 'client-offer') {
                  this.lmsbioCapture.userVerified = false;
                  (this.verifiedFingers as CustomerEnrollmentEntity[]).pop();
                }

                this.stopReaderCapture(true, false);
                this.isFingerProcessing.next(false);
                return;
              }

              this.global_utility.info(this.enrollmentMessage, toastString);
              this.noBiometrics =
                this.userEnrolled.length <= 1 && this.userEnrolled.some((f) => f.fingerName?.includes(NO_FINGER));
              this.lmsbioCapture.canDoEnroll = this.userEnrolled.length < 10 && !this.noBiometrics && isDevMode();

              if (this.biometricType == 'user' && this.userEnrolled.length == 10) {
                this.stopReaderCapture(false, false);
                this.isFingerProcessing.next(false);
                return;
              }

              if (this.biometricType == 'client-offer') {
                if (!this.enrollmentMessage || this.enrollmentMessage == '') {
                  this.lmsbioCapture.canDoVerify = false;
                }

                if (Array.from(this.verifiedFingers).length > 1) {
                  (this.verifiedFingers as CustomerEnrollmentEntity[]).pop();
                }

                (this.verifiedFingers as CustomerEnrollmentEntity[]).push(userFinger);
                this.lmsbioCapture.userVerified =
                  Array.from(this.verifiedFingers).length > 1 && this.verifiedFingers[1] != null;
                this.quoteStoreService
                  .auditLogUserFingerVerification(this.biometricsModel.idNumber, this.enrollmentMessage)
                  .subscribe();
                this.stopReaderCapture(true, false);

               this.signatureChecker.next(2); //3
                if(this.biometricsInfo.FaisRepRequired === true) { //(this.lmsbioCapture.faisRepVerified || !this.lmsbioCapture.faisRepVerified ) &&
                  this.tabsComponent?.setActiveTab(2); //3
                }
              }
              this.isFingerProcessing.next(false);
            },
            complete: () => {
              this.isFingerProcessing.next(false);
              console.groupEnd();
            },
            error: (err) => {
              this.isFingerProcessing.next(false);
              this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
              console.error(err);
              console.groupEnd();
            },
          });
        });
      }
    };
  }

  doRepUserFingerVerify(userFinger: CustomerEnrollmentEntity) {
    if (userFinger?.fingerName === (NO_FINGER as FingerNameEnum) && isDevMode()) {
      //this.skipBiometrics = false;
      this.enableSkip = this.biometricType == 'client';
      this.selectedFingerName = NO_FINGER;
      this.verifiedRepFingers[1] = userFinger;
      //this.signatureOpen = true;
      return;
    }

    if (!this.lmsbioCapture.faisRepVerified && !this.acquisitionStarted) {
      this.startCapture();
      this.showStatus = true;
    }

    this.finger_processing = (oneSample: string[]) => {
      const sampleDataVerify = oneSample[0];
      const biometricsModel = {
        fingerImage: sampleDataVerify,
        verifiedBy: userFinger.userName, //this.userService.userLoginName,
        branchName: this.userBiometricsData?.branchName || this.biometricsInfo?.branchName,
        idNumber: this.biometricsInfo?.idNumber,
        faisRep: this.biometricsInfo?.faisRep,
      };

      if (this.biometricType == 'client-offer') {
        this.biometricsModel.userName = this.userService.userLoginName;
      } else {
        this.biometricsModel.userName = this.biometricsInfo.loginName;
      }

      this.samplesFull = oneSample.length >= 1;
      if (oneSample.length >= 1) {
        this.stopReaderCapture(true, false);
      }
      setTimeout(() => {
        this.isFingerProcessing.next(true);

        this.biometricsService.verifyRepUserFinger(biometricsModel).subscribe({
          next: (response) => {
            this.enrollmentError = response?.errorCode;
            this.enrollmentMessage = response?.errorMessage;

            const toastString = `Verify Finger Response: ${this.enrollmentError}`;
            this.quoteStoreService.setVerifiedMessage(this.enrollmentMessage);

            if (this.enrollmentError == 'FAILURE') {
              this.global_utility.warning(this.enrollmentMessage, toastString);
              this.biometricsModel.fingerVerified = false;

              if (this.biometricType == 'client-offer') {
                //this.signatureOpen = false;
                this.lmsbioCapture.faisRepVerified = false;
                (this.verifiedRepFingers as CustomerEnrollmentEntity[]).pop();
              }
              this.stopReaderCapture(true, false);
            } else {
              this.global_utility.info(this.enrollmentMessage, toastString);
              this.noBiometrics =
                this.userEnrolled.length <= 1 && this.userEnrolled.some((f) => f.fingerName?.includes(NO_FINGER));
              this.lmsbioCapture.canDoEnroll = this.userEnrolled.length < 10 && !this.noBiometrics;

              //this.continueApplicationDisabled = this.biometricType == 'client' && !this.lmsbioCapture.canDoEnroll;

              if (this.biometricType == 'user') {
                this.stopReaderCapture(false, false);
                this.isFingerProcessing.next(false);
                return;
              }

              if (this.biometricType == 'client-offer') {
                if (!this.enrollmentMessage || this.enrollmentMessage == '') {
                  this.lmsbioCapture.canDoVerify = false;
                }

                if (Array.from(this.verifiedRepFingers).length > 0) {
                  (this.verifiedRepFingers as CustomerEnrollmentEntity[]).pop();
                }

                (this.verifiedRepFingers as CustomerEnrollmentEntity[]).push(userFinger);
                this.lmsbioCapture.faisRepVerified = true;

                this.signatureChecker.next(3);

                this.stopReaderCapture(true, false);
              }
            }
            this.isFingerProcessing.next(false);
          },
          complete: () => {
            this.isFingerProcessing.next(false);
            console.groupEnd();
          },
          error: (err) => {
            this.isFingerProcessing.next(false);
            this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
            console.error(err);
            console.groupEnd();
          },
        });
      });
    };
  }

  verifyUserIntermediate() {
    this.lmsbioCapture.sampleData.pipe(
      tap((allSample) => {
        if (allSample.length == 0) {
          this.global_utility.warning('Finger could not be Verified or no finger provided.', '');
          return;
        }

        this.sampleDataVerify = allSample[0];
        this.biometricsModel.fingerImage = this.sampleDataVerify;
        this.biometricsModel.verifiedBy = this.userService.userLoginName;

        if (this.biometricType == 'client-offer') {
          this.biometricsModel.userName = this.userService.userLoginName;
        } else {
          this.biometricsModel.userName = this.biometricsInfo?.loginName;
        }

        this.biometricsService
          .verifyUserFinger(this.biometricsModel)
          .pipe(
            tap(() => {
              console.group('Verify user finger');
            })
          )
          .subscribe({
            next: (response) => {
              console.debug(`Verify User finger result >>`, response);
              this.enrollmentError = response?.errorCode;
              this.enrollmentMessage = response?.errorMessage;
              this.lmsbioCapture.canDoEnroll = false;
              this.biometricsService.resetReadings();

              if (this.biometricType == 'client-offer') {
                this.quoteStoreService
                  .auditLogUserFingerVerification(this.biometricsModel.idNumber, this.enrollmentMessage)
                  .subscribe();
              }

              const toastString = `Verify Finger Response: ${this.enrollmentError}`;
              if (this.enrollmentError == 'FAILURE') {
                this.global_utility.warning(this.enrollmentMessage, toastString);
              } else {
                this.global_utility.info(this.enrollmentMessage, toastString);
                this.lmsbioCapture.userVerified = true;
                this.lmsbioCapture.faisRepVerified = true;
                this.stopReaderCapture(false, false);
              }
              console.groupEnd();
            },
            complete() {
              console.groupEnd();
            },
          });
      })
    );
  }

  verifyBranchManager(_isfaisRep: boolean = false) {
    if (!this.biometricsModel.bmUserName) {
      this.global_utility.warning('Please Enter a valid Branch Manger Username.', '');
      this.biometricsService.resetReadings();
      this.stopReaderCapture(false, false);
      return;
    }

    if (
      this.biometricsModel.bmUserName === this.userService.userLoginName &&
      this.userService.userJobTitle === 'Branch Consultant'
    ) {
      this.global_utility.warning('Please enter a valid Branch Manager username.', '');
      this.stopReaderCapture(true, false);
      return;
    }

    if (!this.lmsbioCapture.userVerified && (!this.lmsbioCapture.faisRepVerified || !this.biometricsInfo.FaisRepRequired) && !this.acquisitionStarted) {
      this.startCapture(true, false);
      this.showStatus = true;
    }

    this.finger_processing = (oneSample: string[]) => {
      if (Array.isArray(this.sampleDataVerify) && Array.from(this.sampleDataVerify).length >= 1) {
        return;
      }

      this.sampleDataVerify = oneSample[0];
      this.biometricsModel.fingerImage = this.sampleDataVerify;
      this.biometricsModel.fingerName = this.selectedFingerName;
      this.biometricsModel.verifiedBy = this.biometricsModel.bmUserName;
      this.biometricsModel.userName = this.userService.userLoginName;
      this.biometricsModel.branchName = this.userService.userBranchName;

      this.biometricsModel.skipReason = 'No Biometrics, BM Override';
      this.samplesFull = oneSample.length >= 1;
      if (oneSample.length >= 1) {
        this.stopReaderCapture(true, false);
      }
      //if(this.userService.userJobTitle.jobTitle === 'Branch Manager' && this.biometricsModel.bmUserName != ''){
      this.biometricsService.verifyUserFinger(this.biometricsModel).subscribe({
        next: (response) => {
          console.debug(`Verify User[BM] finger result >>`, response);
          this.enrollmentError = response?.errorCode;
          this.enrollmentMessage = response?.errorMessage;

          this.lmsbioCapture.canDoEnroll = false;

          const toastString = `Verify Finger Response: ${this.enrollmentMessage}`;
          if (this.enrollmentError == 'FAILURE') {
            this.global_utility.warning(this.enrollmentMessage, toastString);
            this.bmVerified = false;
            this.enableSkip = false;
          } else {
            this.global_utility.info(this.enrollmentMessage, toastString);
            this.bmVerified = true;
            if (this.clientEnrolled.length < 4) {
              setTimeout(() => {
                this.biometricsModel.skipReason = 'No Biometrics, BM Override';
                this.selectedFingerName = NO_FINGER;
                this.biometricsModel.fingerName = NO_FINGER;
                this.skipRegistration();
              }, 200);
            } else {
              // Client Finger disable required
              this.global_utility.warning('Client finger to be disabled to allocate No Finger', 'Max Finger Enrolled');
              this.bmVerified = true;
              /// TODO: Fix this
            }
          }
          this.stopReaderCapture(true, false);
          console.groupEnd();
        },
        complete() {
          console.groupEnd();
        },
      });
      // }
      // else {
      //   this.global_utility.warning("Branch Username is required " , '');
      // }
    };
  }

  getClientEnrolledFingers(force_fetch: boolean = false) {
    console.log('Retrieving Client Enrolled Fingers...');

    if (
      this.clientEnrolled.length > 0 &&
      this.biometricsInfo?.idNumber == this.biometricsModel.idNumber &&
      !force_fetch
    ) {
      console.debug('User Enrolled details already retrieved');
      return;
    }
    this.showDisabledTab = false;
    this.biometricsModel.idNumber = this.biometricsInfo?.idNumber || this.biometricsInfo;

    setTimeout(() => {
      this.biometricsService
        .enrolledFingersDetails(this.biometricsModel.idNumber)
        .pipe(
          tap(() => {
            console.group('Get Client Enrolled');
            console.debug('Retrieving Client Enrolled Fingers...');
          })
        )
        .subscribe({
          next: (result) => {
            console.debug('Enrolled finger Data ($):', result);
            this.clientEnrolled = result;
            this.lmsbioCapture.canDoEnroll = false;
            this.lmsbioCapture.canDoVerify = false;
            this.lmsbioCapture.isValidFingerSelected = false;

            this.showStatus = false;
            //this.noBiometrics = (!this.clientEnrolled.some(f => f.fingerName?.includes(NO_FINGER)) && this.clientEnrolled.length <= 1) || this.clientEnrolled.length == 0;
            this.noBiometrics =
              this.clientEnrolled.some((f) => f.fingerName?.includes(NO_FINGER)) && this.clientEnrolled.length <= 1;

            this.continueApplicationDisabled =
              (this.clientEnrolled.length >= 4 || !this.noBiometrics) && !this.lmsbioCapture.clientVerified;
            //this.enableSkip = this.noBiometrics && this.biometricType == 'client' && this.clientEnrolled.length > 0;

            if (this.continueApplicationDisabled) {
              this.lstAllFingersDisable = true;
              this.showDisabledTab = this.clientEnrolled.length > 0 && this.biometricType != 'client-offer';
              this.selectedFingerNameControl.enable();
              this.lmsbioCapture.canDoVerify = !this.lmsbioCapture.clientVerified;
              this.lmsbioCapture.canDoEnroll = this.biometricType != 'client-offer' && this.clientEnrolled.length < 4;
              //this.skipBiometrics = this.clientEnrolled.some(f => f.fingerName?.includes(NO_FINGER));
            } else if (this.noBiometrics && this.selectedFingerName == '') {
              this.showDisabledTab = this.biometricType != 'client-offer';
              this.selectedFingerNameControl.enable();
              this.selectedFingerName = NO_FINGER;
              //this.skipBiometrics = true;
              this.lmsbioCapture.canDoVerify = true;
            } else {
              this.selectedFingerNameControl.disable();
              this.lmsbioCapture.canDoEnroll = this.biometricType != 'client-offer' && this.clientEnrolled.length < 4;
              this.lmsbioCapture.canDoVerify = true;
              this.showDisabledTab = this.biometricType != 'client-offer';
              //this.openVerification();
              //const test = this.captureOpen && (!this.lmsbioCapture.canDoEnroll || this.lmsbioCapture.canDoEnroll) && !this.lmsbioCapture.clientVerified;
            }

            this.isFingerProcessing.next(false);
            this.getFingersList(this.clientEnrolled, this.biometricType);
            this.lmsbioCapture.isValidFingerSelected = false;
          },
          complete: () => {
            this.isFingerProcessing.next(false);
            console.groupEnd();
          },
          error: (err) => {
            this.isFingerProcessing.next(false);
            this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
            console.error(err);
            console.groupEnd();
          },
        });
    });
  }

  disableClientFinger(id: any) {
    this.biometricsModel.id = id;
    this.biometricsModel.userName = this.userService.userLoginName;
    //this.biometricsModel.disableReason = this.biometricsModel.disableReason;

    this.isFingerProcessing.next(true);
    setTimeout(() => {
      this.biometricsService.disableFinger(this.biometricsModel).subscribe({
        next: (response) => {
          console.debug('Disable Finger >> Response: ', response);

          this.fingerdisabled = id;
          this.enrollmentError = response?.errorCode;
          this.enrollmentMessage = response?.errorMessage;

          if (this.enrollmentError != 'SUCCESS') {
            this.stopReaderCapture(true, false);
            this.global_utility.error(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'Client Disable Error');
            this.lmsbioCapture.canDoEnroll = true;
            this.lmsbioCapture.isValidFingerSelected = false;
            this.samplesFull = false;
            this.isFingerProcessing.next(false);
            return;
          }

          this.lmsbioCapture.isValidFingerSelected = false;
          this.getClientEnrolledFingers(true);
        },
        complete: () => {
          this.isFingerProcessing.next(false);
          console.groupEnd();
        },
        error: (err) => {
          this.isFingerProcessing.next(false);
          this.global_utility.error(`${err} : ${err}`, 'Client Disable Error');
          console.error(err);
          console.groupEnd();
        },
      });
    });
  }

  disableAllClientFingers() {
    this.biometricsModel.idNumber = this.biometricsInfo?.idNumber;
     this.biometricsModel.userName = this.userService.userLoginName;
    setTimeout(() => {
      this.biometricsService.disableAllClientFingers(this.biometricsModel).subscribe((responseData) => {
        console.log('Response', responseData);

        this.enrollmentError = responseData?.errorCode;
        this.enrollmentMessage = responseData?.errorMessage;

        this.getClientEnrolledFingers(true);
      });
    });
  }

  enrollUser() {
    if (!this.lmsbioCapture.isValidFingerSelected || !this.lmsbioCapture.canDoEnroll) {
      this.global_utility.warning('Please select a valid finger to enroll.', 'Enrollment Warning');
      return;
    }
    this.isFingerProcessing.next(true);


      this.biometricsModel.fingerName = this.selectedFingerName;
      this.biometricsModel.enrolledBy = this.userService.userDisplayName;
      this.biometricsModel.loginName = this.biometricsInfo?.loginName;
      this.biometricsModel.branchName = this.biometricsInfo?.branchName;
      this.biometricsModel.faisRep = this.biometricsInfo?.faisRep;

      this.showStatus = false;
      this.isFingerProcessing.next(true);

      this.biometricsService.enrollUserFinger(this.biometricsModel).subscribe({
        next: (response) => {
          this.enrollmentError = response?.errorCode;
          this.enrollmentMessage = response?.errorMessage;

          if (this.enrollmentError != 'SUCCESS') {
            this.stopReaderCapture(true, false);
            this.global_utility.error(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'Enrollment Error: ');
            this.lmsbioCapture.canDoEnroll = true;
            this.lmsbioCapture.isValidFingerSelected = false;
            this.samplesFull = false;
            this.isFingerProcessing.next(false);
            return;
          }

          // Reset selectedFingerName, stop client capture, and update enrolled and fingers list
          this.global_utility.success(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'Enrollment Status');
          this.selectedFingerNameControl.reset();
          this.selectedFingerName = '';
          this.samplesFull = false;
          this.lmsbioCapture.isValidFingerSelected = false;

          if (this.userEnrolled.length == 9) {
            this.startAcquisitionDisabled = false;
            this.selectedFingerNameControl.disable();
            this.lstAllFingersDisable = true;
          } else {
            this.startAcquisitionDisabled = true;
            this.selectedFingerNameControl.enable();
            this.lstAllFingersDisable = false;
          }
          this.isFingerProcessing.next(false);
        },
        complete: () => {
          this.isFingerProcessing.next(false);
          this.getUserEnrolledFingers(true);
          console.groupEnd();
        },
        error: (err) => {
          this.isFingerProcessing.next(false);
          this.global_utility.error(`${err} : ${err}`, 'Enrollment Error: ');
          console.error(err);
          console.groupEnd();
        },
      });
  }

  getUserEnrolledFingers(force_fetch: boolean = false) {
    if (!force_fetch) {
      console.debug('User Enrolled details already retrieved');
      return;
    }

    // Set the userName based on the biometric type
    this.biometricsModel.userName =
      this.biometricType === 'client-offer' ? this.userService.userLoginName : this.biometricsInfo?.loginName;
    this.biometricsModel.branchName = this.userBiometricsData?.branchName || this.biometricsInfo?.branchName;

    this.showUserDisabledTab = false;
    this.captureOpen = this.biometricType !== 'client-offer';
    this.lmsbioCapture.canDoEnroll = true;
    this.lmsbioCapture.canDoVerify = this.userEnrolled.length >= 1;


      this.startAcquisitionDisabled = false;
      this.selectedFingerNameControl.enable();
      this.isFingerProcessing.next(true);
      this.biometricsService.enrolledUserFingersDetails(this.biometricsModel).pipe(filter(fp =>
        force_fetch || (fp != null && fp.length > 0)), tap(() => {
          this.isFingerProcessing.next(false);
          console.group('Get User Enrolled');
          console.debug('Retrieving User Enrolled Fingers...');
        }
      )).subscribe({
        next:(result) => {
          setTimeout(() => {
          console.debug('Enrolled Data', result);

          this.userRecord = result;
          const _otherUserEnrolled = this.userRecord?.filter((user) => user.faisRep == true) || [];

          this.uniqueUsernames = Array.isArray(_otherUserEnrolled)
            ? [...new Set(_otherUserEnrolled.map((user) => user.userName))]
            : [];

            const uName = this.biometricType === 'client-offer' ? this.biometricsModel.userName : this.biometricsInfo?.loginName;
          this.otherUserEnrolled = _otherUserEnrolled;
          this.userEnrolled = this.userRecord.filter(ur => ur.userName == uName && ur.disabledAt == null);

          this.showStatus = false;
          this.noBiometrics =
            (!this.userEnrolled.some((f) => f.fingerName?.includes(NO_FINGER)) && this.userEnrolled.length <= 1) ||
            this.userEnrolled.length == 0;
          this.continueApplicationDisabled = true;
          this.enableSkip = false;

          if (this.biometricType === 'user' || this.biometricType === 'client-offer') {

            // Check if all fingers have been enrolled
            this.lstAllFingersDisable = this.userEnrolled.length == 10;
            this.showUserDisabledTab = this.userEnrolled.length > 0 && this.biometricType === 'user';
            this.captureOpen = this.biometricType !== 'client-offer';

            if (this.lstAllFingersDisable || (this.biometricType === 'client-offer' && this.otherUserEnrolled.length >= 10)) {
              this.noBiometrics = false;
              this.showUserDisabledTab = false;
              this.selectedFingerNameControl.disable();
              this.startAcquisitionDisabled = true;
              this.lmsbioCapture.canDoEnroll = false;
              this.lmsbioCapture.canDoVerify = true;
              this.captureOpen = false;
            } else {
                if (this.biometricType === 'user') {
                  this.showUserDisabledTab = this.userEnrolled.length > 0;
                  this.captureOpen = true;
                  this.lmsbioCapture.canDoEnroll = true;
                  this.lmsbioCapture.canDoVerify = this.userEnrolled.length >= 1;

                  this.startAcquisitionDisabled = false;
                  this.selectedFingerNameControl.enable();
              }
            }
            this.isFingerProcessing.next(false);

            this.getFingersList(this.userEnrolled, this.biometricType);
          }
          });
          console.groupEnd();
        },
        complete: () => {
          this.isFingerProcessing.next(false);
          console.groupEnd();
        },
        error: (err) => {
          this.isFingerProcessing.next(false);
          console.groupEnd();
          console.error('user enrolled finger error: ', err);
        },
      });

  }

  disableUserFinger(id: any) {
    this.biometricsModel.id = id;
    this.biometricsModel.userName = this.userService.userLoginName;
    this.isFingerProcessing.next(true);
    this.biometricsService.disableUserFinger(this.biometricsModel).subscribe({
      next:(response) => {
        console.debug('disable User finger repsonse >>', response);

        this.fingerdisabled = id;
        this.enrollmentError = response?.errorCode;
        this.enrollmentMessage = response?.errorMessage;

        if (this.enrollmentError != 'SUCCESS') {
          this.stopReaderCapture(true, false);
          this.global_utility.error(`${this.enrollmentError} : ${this.enrollmentMessage}`, 'User Disable Error:');
          this.lmsbioCapture.canDoEnroll = true;
          this.lmsbioCapture.isValidFingerSelected = false;
          this.samplesFull = false;
          this.isFingerProcessing.next(false);
          return;
        }

        this.lmsbioCapture.isValidFingerSelected = false;
        this.getClientEnrolledFingers(true);
      },
      complete: () => {
        this.isFingerProcessing.next(false);
        console.groupEnd();
      },
      error: (err) => {
        this.isFingerProcessing.next(false);
        this.global_utility.error(`${err} : ${err}`, 'User Disable Error:');
        console.error(err);
        console.groupEnd();
      },
    });
  }

  disableAllUserFingers() {
    this.biometricsModel.disabledBy = this.userService.userLoginName;
    this.biometricsModel.userName = this.biometricsInfo?.loginName;
    this.isFingerProcessing.next(true);
    this.biometricsService.disableAllUserFingers(this.biometricsModel).subscribe((response) => {
      if (response) {
        console.debug('disable ALL User finger repsonse>>', response);

        this.enrollmentError = response?.errorCode;
        this.enrollmentMessage = response?.errorMessage;
        this.isFingerProcessing.next(false);
        this.getUserEnrolledFingers(true);
      }
    });
  }

  openReader() {
    this.captureOpen = false;
    this.showDisabledTab = false;
    this.showUserDisabledTab = false;
    this.verificationOpen = false;
    this.userVerificationOpen = false;
    //this.signatureOpen = false;
  }

  openUserCapture() {
    this.captureOpen = true;
    this.showDisabledTab = false;
    this.showUserDisabledTab = false;
    //this.signatureOpen = false;
  }

  openDisableFinger() {
    this.showDisabledTab = true;
    this.showUserDisabledTab = true;
    this.captureOpen = false;
    this.verificationOpen = false;
    // this.signatureOpen = false;
  }

  backToPreAuth() {
    this.modalRef.close(this.biometricsModel);
  }

  continueApplication() {
    /// NOTHING ENROLLED
    if (this.clientEnrolled.length == 0) {
      this.enableSkip = true;

      this.isCellVisible = Boolean(this.biometricsInfo.hasCell != 'No');
      this.skipBiometrics = Boolean(this.biometricsModel.bmUserName && this.biometricsModel.bmUserName != '') ?? false;
      this.selectedFingerName = this.biometricsInfo.hasCell == 'No' && this.skipBiometrics ? NO_FINGER : null;

      this.biometricsModel.fingerVerified =
        Boolean(this.biometricsModel.bmUserName && this.biometricsModel.bmUserName != '') ?? false;
      this.biometricsModel.cellNoExist = this.biometricsInfo.cellNumber != '0' ? 'Yes' : 'No';
    }
    /// ONE FINGER ENROLLED
    else if (this.clientEnrolled.length == 1 || this.noBiometrics) {
      this.enableSkip = true;
      this.isCellVisible = Boolean(this.biometricsInfo.hasCell != 'No');

      this.skipBiometrics = Boolean(this.biometricsModel.bmUserName && this.biometricsModel.bmUserName != '') ?? false;
      this.selectedFingerName = this.skipBiometrics ? NO_FINGER : null;

      this.biometricsModel.fingerVerified = this.skipBiometrics;
      this.biometricsModel.cellNoExist = this.biometricsInfo.cellNumber != '0' ? 'Yes' : 'No';
    }
    // MORE OR ALL
    else {
      this.skipBiometrics = Boolean(this.biometricsModel.bmUserName && this.biometricsModel.bmUserName != '') ?? false;

      this.isCellVisible = false;
      this.biometricsModel.cellNoExist = this.biometricsInfo.cellNumber != '0' ? 'Yes' : 'No';
      this.biometricsModel.fingerVerified =
        // if BM has scanned then override else client must verify
        this.biometricsModel.bmUserName ? true : this.lmsbioCapture.clientVerified;

      this.biometricsModel.fingerName = this.selectedFingerName;
    }

    this.biometricsModel.verifiedMessage = this.quoteStoreService.verifiedMessage || this.enrollmentMessage;
    if (this.biometricsModel.fingerVerified) {
      this.closeDialog();
    }
  }

  getClientFingersCount() {
    return this.clientEnrolled.length <= 4;
  }

  getUserFingersCount() {
    return this.userEnrolled.length <= 4;
  }

  getFingersList(activeFingers: CustomerEnrollmentEntity[] | [], biotype: string = 'client') {
    const selector = biotype === 'user' ? '#allFingersSelectUser' : '#allFingersSelect';
    const childComp = biotype === 'user' ? this.allFingerUser : this.allFinger;
    const domElement = document.querySelector(selector);
    let selectElement: HTMLSelectElement | null = null;

    if (domElement instanceof HTMLSelectElement) {
      selectElement = domElement;
    } else if (childComp && childComp.nativeElement instanceof HTMLSelectElement) {
      selectElement = childComp.nativeElement;
    }

    if (!selectElement || activeFingers?.length == 0) {
      return;
    }

    // Create a copy of options to avoid issues while removing options during iteration
    const optionsArray = Array.from(selectElement.options);
    optionsArray.forEach((option) => {
      if (activeFingers.some((a) => a.fingerName == option.value.split(':')[1]?.trim())) {
        selectElement?.remove(option.index);
      }
    });
  }

  continueClientDisabled() {
    this.continueApplicationDisabled =
      (this.clientEnrolled.length < 4 ||
        !(this.clientEnrolled.length == 1 && this.clientEnrolled.some((f) => f.fingerName?.includes(NO_FINGER)))) &&
      !this.lmsbioCapture.clientVerified;
  }

  continueUserDisabled() {
    this.continueApplicationDisabled =
      this.clientEnrolled.length < 4 ||
      !(this.clientEnrolled.length == 1 && this.clientEnrolled.some((f) => f.fingerName?.includes(NO_FINGER)));
  }

  backToOffers() {
    this.enableSkip = false;
  }

  continueLoan() {
    const hasCellNumber = this.biometricsInfo.cellNumber !== '0' || this.biometricsInfo.hasCell == 'Yes';
    const hasNoSelectedFinger = this.selectedFingerName == NO_FINGER;

    this.enableSkip = false;
    this.skipBiometrics = true;
    this.isCellVisible = hasCellNumber && hasNoSelectedFinger;
  }

  onfingerChange(target: any) {
    if (target.value === NO_FINGER) {
      if (this.biometricType == 'user' || (this.biometricType == 'client' && this.clientEnrolled.length <= 1)) {
        this.startAcquisitionDisabled = true;
        this.continueApplicationDisabled = true;
        this.enableSkip = this.clientEnrolled.length <= 1;
        this.skipBiometrics = false;
        this.noBiometrics = true;
        this.selectedFingerName = NO_FINGER;
        this.lmsbioCapture.isValidFingerSelected = false;
      }
      return;
    }

    this.enableSkip = false;
    const value: string = target.value;
    this.selectedFingerName = value?.trim() || '';
    //this.lmsbioCapture.canDoEnroll = this.biometricType == 'client' ? this.clientEnrolled.length < 4 : this.userEnrolled.length < 10;
    this.lmsbioCapture.isValidFingerSelected =
      this.selectedFingerName && (this.selectedFingerName !== 'null' || this.selectedFingerName !== '');
    this.continueApplicationDisabled = true;
    this.startAcquisitionDisabled = !this.lmsbioCapture.isValidFingerSelected;
  }

  skipRegistration() {
    if (this.biometricsModel.skipReason == 'N/A') {
      this.submitted = false;
      return;
    }

    this.submitted = true;
    this.enableSkip = true;
    setTimeout(() => {
      this.biometricsModel.cellNoExist = this.biometricsInfo.hasCell;
      this.biometricsModel.idNumber = this.biometricsInfo?.idNumber;
      this.biometricsModel.fingerName = this.selectedFingerName;
      this.biometricsModel.enrolledBy = this.userService.userLoginName;

      this.isFingerProcessing.next(true);
      this.biometricsService.skipBiometrics(this.biometricsModel).subscribe({
        next: (response: { errorCode: string; errorMessage: string }) => {
          console.debug(
            `Skip Registration ${this.selectedFingerName == NO_FINGER ? 'NO_FINGER' : ''} repsonse >>`,
            response
          );
          this.enrollmentError = response?.errorCode;
          this.enrollmentMessage = response?.errorMessage;
          this.isFingerProcessing.next(false);
          this.continueApplication();
        },
        error: (error) => {
          this.isFingerProcessing.next(false);
          this.submitted = false;
          this.enableSkip = false;
          this.global_utility.error(error, 'Override Error');
        },
      });
    });
  }

  fetchFinger(selectedFingerName: any) {
    this.selectedFingerName = selectedFingerName;

    const selectedFinger = this.clientEnrolled.find((item) => item.fingerName === this.selectedFingerName);

    if (selectedFinger) {
      this.biometricsService.enrolledSingleFingersDetails(selectedFinger.id).subscribe((result) => {
        console.debug(`Fetch finger ${selectedFingerName} result >>`, result);
        this.lstSignedFingerDetails = result;
      });
    }
  }

  fetchConsultantFinger(selectedConsultantFingerName: string): void {
    this.selectedConsultantFingerName = selectedConsultantFingerName;
    const data: any = this.findUserEnrolledItem();

    this.biometricsService.enrolledConsultantSingleFingersDetails(data?.id).subscribe((result: any) => {
      console.debug(`Fetch consultant finger ${selectedConsultantFingerName} result >>`, result);
      this.lstConsultantSignedFingerDetails = result;
    });
  }

  findUserEnrolledItem(): any {
    return this.userEnrolled.find((item: any) => item.fingerName === this.selectedConsultantFingerName);
  }

  signDocument() {
    const finger1 = this.verifiedFingers[0];
    const finger2 = this.verifiedFingers[1];
    const finger3 = this.verifiedRepFingers[0];

    setTimeout(() => {
      if (finger1 && finger2 && (finger3 || !this.biometricsInfo.FaisRepRequired)) {
        this.biometricsModel.id = this.quoteStoreService.quoteWorkbook.id;

        this.biometricsModel.fingerId = Number(finger1.id);
        if (finger1.fingerName?.includes(NO_FINGER)) {
          this.biometricsModel.fingerId = 0;
        } else {
          this.biometricsModel.fingerId = Number(finger1.id);
        }

        this.isFingerProcessing.next(true);
        this.biometricsModel.userFingerId = Number(finger2.id);
        this.biometricsModel.faisRepFingerId = Number(finger3?.id || 0);
        this.biometricsModel.faisRepUserName = String(finger3?.userName || '');
        this.biometricsModel.isFaisRep = Boolean(finger3?.faisRep || false);
        this.biometricsModel.faisRepFingerId = Number(finger3?.id || 0);
        this.biometricsModel.faisRepUserName = String(finger3?.userName || '');
        this.biometricsModel.isFaisRep = Boolean(finger3?.faisRep || false);
        this.biometricsModel.branchEmail = this.userService.getLMSProfile().email ?? '';

        const saveFingerIdPromise = new Promise<boolean>((resolve, reject) => {
          this.quoteStoreService.saveFingerId(this.biometricsModel).subscribe({
            next: (res: any) => {
              console.debug(`Save FingerId result >>`, res);
              if (!res) {
                resolve(false);
                return;
              }

              this.quoteStoreService.quoteWorkbook.fingerId = res.fingerId;
              this.quoteStoreService.quoteWorkbook.userFingerId = res.userFingerId;
              this.quoteStoreService.quoteWorkbook.faisRepFingerId = res.faisRepFingerId;
              resolve(true);
            },
            error: (err) => {
              this.global_utility.error(`Error on signature: ${err}`, `Document signing error`);
              reject(new Error(`Error on signature: ${err}`));
            },
          });
        });

        console.debug('Biometric Data >>', this.biometricsModel);
        saveFingerIdPromise
          .then((found: boolean) => {
            if (found) {
              this.isFingerProcessing.next(false);
              this.closeDialog();
            }
          })
          .catch((error) => {
            this.isFingerProcessing.next(false);
            console.error(error);
          });
      } else {
        console.info('Finger not Found (Promise saveFinger)');
      }
    });
  }

  doSigning() {
    if (this.isNokComplete) {
      this.closeDialog();
    }
  }

  onSkipReasonChange(event: any) {
    this.submitted = !event || event === 'N/A';
  }

  closeDialog() {
    this.modalRef.close(this.biometricsModel);
  }

  close() {
    this.modalRef.close();
  }

  closeScanFingers() {
    this.showMessage('Closing..please wait');
    this.stopReaderCapture(true, false);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => {
      x.unsubscribe();
    });
    this.closeScanFingers();
  }

  selectedUser: string = '';
  filteredFingers: CustomerEnrollmentEntity[] | [];

  filterFingerprints() {
    if (this.selectedUser) {
      const selectedUserData = this.otherUserEnrolled.find((user) => user.userName === this.selectedUser);
      this.filteredFingers = selectedUserData ? [selectedUserData] : [];
    } else {
      this.filteredFingers = [];
    }
  }

    flagForCallCentreApproval(){
    console.log('Flagging for Call Centre Approval...', this.quoteStoreService.quoteWorkbook);
    this.quoteStoreService.quoteWorkbook.updatedBy = this.global_utility.getGlobalData('userDisplay');
    this.quoteStoreService.aulOverride(this.quoteStoreService.quoteWorkbook ).subscribe({
     next: (quoteresult: any) => {
        this.lmsbioCapture.faisRepVerified
          this.global_utility.stopLoading();
          this.close();
          this.global_utility.navigateToLanding();
        },
        error: (err) => {
          this.global_utility.stopLoading();
        },
      });
 }

}
